var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 0h14v2h-4v2h-2V2H7v3h2v2H7v2H5V7H2v3h2v2H2v4H0V0h2zm3 5H2V2h3v3zm10.805 1.695c.26-.26.26-.68 0-.94l-1.56-1.56a.664.664 0 00-.94 0l-1.22 1.22 2.5 2.5 1.22-1.22zM4 13.5V16h2.5l7.372-7.372-2.5-2.5L4 13.5z","fill":"#919DAF"}));
}

Edit.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Edit;

Edit.default = Edit;
